import { ValueType } from "@/enums/ValueType";
import type { MortgagePart } from "@loanlink-nl/model-app";
export type { MortgagePart };

export const NumericValueTypes: ValueType[] = [
	ValueType.Currency,
	ValueType.Percentage,
	ValueType.Number,
];

export const MortgagePartFieldType: Record<
	Exclude<keyof MortgagePart, "id" | "existingMortgagePartId">,
	ValueType
> = {
	amount: ValueType.Currency,
	repaymentForm: ValueType.String,
	productCode: ValueType.String,
	durationMonths: ValueType.Number,
	fixedInterestMonths: ValueType.Number,
	interestRate: ValueType.Percentage,
	endDate: ValueType.Date,
	interestDeductionLaw: ValueType.String,
	interestDeductionEndDate: ValueType.Date,
	fixedInterestEndDate: ValueType.Date,
	interestRateType: ValueType.String,
	interestReflectionPeriod: ValueType.String,
	interestReflectionPeriodMonths: ValueType.Number,
	repaymentStrategy: ValueType.String,
};
